<template>
  <sea-page title="Home">
    <v-layout column justify-space-between class="h100">
      <div id="last-payroll">
        <v-layout justify-space-between>
          <div class="title text-body-2 text-lg-h6">Ultima busta paga</div>
          <div class="text-body-2 text-lg-h6 font-weight-black">
            Privacy {{ viewData ? "OFF" : "ON" }}
            <v-icon class="ml-5" @click.prevent="changeViewData"
              >mdi-eye-off</v-icon
            >
          </div>
        </v-layout>
        <v-data-table
          class="mb-2"
          mobile-breakpoint="960"
          :headers="headers"
          :items="[lastPayroll]"
          disable-sort
          dense
          hide-default-footer
        >
          <template v-slot:item.mese="{ item }">
            {{ mesi[item.mese - 1] }}
          </template>
          <template v-slot:item.netto="{ item }">
            <span v-if="viewData">
              {{ item.netto | currencyFormat }}
            </span>
            <span v-else>*****</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              elevation="2"
              rounded
              x-small
              @click="editItem(item)"
              color="primary"
              class="mr-2"
            >
              Dettaglio
              <v-icon right dark>mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              elevation="2"
              rounded
              x-small
              @click="download(item)"
              color="primary"
            >
              Apri
              <v-icon right dark>mdi-cloud-download </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </div>
      <v-divider></v-divider>
      <div id="donut">
        <el-carousel
          trigger="click"
          type="card"
          :autoplay="false"
          :height="donutHeight"
        >
          <el-carousel-item
            v-if="
              lastPayroll &&
              lastPayroll.ferie &&
              (lastPayroll.ferie.totale.maturato !== 0 ||
                lastPayroll.ferie.totale.goduto !== 0 ||
                lastPayroll.ferie.totale.residuo !== 0)
            "
          >
            <donut-chart title="Ferie" :data="lastPayroll.ferie"></donut-chart>
          </el-carousel-item>
          <el-carousel-item
            v-if="
              lastPayroll &&
              lastPayroll.permessi &&
              (lastPayroll.permessi.totale.maturato !== 0 ||
                lastPayroll.permessi.totale.goduto !== 0 ||
                lastPayroll.permessi.totale.residuo !== 0)
            "
          >
            <donut-chart
              title="Permessi"
              :data="lastPayroll.permessi"
            ></donut-chart>
          </el-carousel-item>
          <el-carousel-item
            v-if="
              lastPayroll &&
              lastPayroll.altreMov &&
              (lastPayroll.altreMov.totale.maturato !== 0 ||
                lastPayroll.altreMov.totale.goduto !== 0 ||
                lastPayroll.altreMov.totale.residuo !== 0)
            "
          >
            <donut-chart
              title="Altre movimentazioni"
              :data="lastPayroll.altreMov"
            ></donut-chart>
          </el-carousel-item>
          <el-carousel-item
            v-if="
              lastPayroll &&
              lastPayroll.bancaOre &&
              (lastPayroll.bancaOre.totale.maturato !== 0 ||
                lastPayroll.bancaOre.totale.goduto !== 0 ||
                lastPayroll.bancaOre.totale.residuo !== 0)
            "
          >
            <donut-chart
              title="Banca ore"
              :data="lastPayroll.bancaOre"
            ></donut-chart>
          </el-carousel-item>
          <el-carousel-item
            v-if="
              lastPayroll &&
              lastPayroll.presenze &&
              lastPayroll.assenze &&
              (lastPayroll.presenze.lavorate !== 0 ||
                lastPayroll.presenze.straordinario !== 0 ||
                lastPayroll.assenze.totale !== 0)
            "
          >
            <v-layout column>
              <v-flex
                class="
                  text-center
                  font-weight-black
                  mb-1
                  text-caption text-lg-body-1 text-truncate
                "
              >
                Presenze/assenze
              </v-flex>
              <v-flex>
                <vc-donut
                  :size="donutSize"
                  :sections="[
                    { value: lastPayroll.presenze.lavorate, color: '#011ee9' },
                    {
                      value: lastPayroll.presenze.straordinario,
                      color: '#5eb0e1',
                    },
                    { value: lastPayroll.assenze.totale, color: '#e03110' },
                  ]"
                  :total="
                    parseFloat(
                      (
                        lastPayroll.presenze.lavorate +
                        lastPayroll.presenze.straordinario +
                        lastPayroll.assenze.totale
                      ).toFixed(2)
                    )
                  "
                >
                  <div class="text-little-6 text-lg-caption">
                    Lavorate ore:
                    <span style="color: #011ee9">{{
                      lastPayroll.presenze &&
                      lastPayroll.presenze.lavorate | roundNumber
                    }}</span>
                    <br />
                    Straordinario ore:
                    <span style="color: #5eb0e1">{{
                      lastPayroll.presenze &&
                      lastPayroll.presenze.straordinario | roundNumber
                    }}</span>
                    <br />
                    Assenze ore:
                    <span style="color: #e03110">{{
                      lastPayroll.assenze &&
                      lastPayroll.assenze.totale | roundNumber
                    }}</span>
                  </div>
                </vc-donut>
              </v-flex>
            </v-layout>
          </el-carousel-item>
        </el-carousel>
      </div>
      <v-divider></v-divider>
      <div id="chart">
        <v-layout justify-space-between>
          <div class="title text-body-2 text-lg-h6">
            Retribuzione e trattenute
          </div>
        </v-layout>
        <retribuzione-trattenute-home-widget
          ref="graf"
          :viewData="viewData"
          :fetchYearData="fetchYearData"
          :yearData="yearData"
        ></retribuzione-trattenute-home-widget>
      </div>
    </v-layout>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DonutChart from "@/components/DonutChart.vue";
import RetribuzioneTrattenuteHomeWidget from "@/components/HomeWidget/RetribuzioneTrattenuteHomeWidget.vue";

import { mesi } from "@/constants";

const headers = [
  {
    text: "Mese",
    value: "mese",
    class: "bgHead",
    cellClass: "font-weight-black",
  },
  {
    text: "Anno",
    value: "anno",
    class: "bgHead",
    cellClass: "font-weight-black",
  },
  {
    text: "Tipologia",
    value: "descrizione",
    class: "bgHead",
    cellClass: "font-weight-black",
  },
  {
    text: "Netto",
    value: "netto",
    class: "bgHead",
    cellClass: "font-weight-black",
  },
  { text: "", value: "actions", class: "bgHead", cellClass: "text-end" },
];
export default {
  name: "home",
  components: {
    DonutChart,
    RetribuzioneTrattenuteHomeWidget,
  },
  async created() {
    this.anno = new Date().getFullYear();
    await this.fetchLast();
    await this.fetchYearData(this.anno);
    this.viewData = localStorage.getItem("viewData") === "true";
  },
  data: () => ({
    viewData: null,
    model: 0,
    headers,
    mesi,
  }),
  methods: {
    ...mapActions({
      fetchLast: "payroll/fetchLastPayroll",
      fetchYearData: "employee/fetchYearData",
      download: "payroll/downloadPayroll",
    }),
    editItem(item) {
      this.$router.push({ name: "payrollDetail", params: { id: item.id } });
    },
    changeViewData() {
      this.viewData = !this.viewData;
      localStorage.setItem("viewData", this.viewData);
    },
  },
  computed: {
    ...mapGetters({
      lastPayroll: "payroll/last",
      yearData: "employee/yearData",
    }),
    donutHeight() {
      if (
        this.$vuetify.breakpoint.name == "lg" ||
        this.$vuetify.breakpoint.name == "xl"
      ) {
        return "200px";
      }
      return "150px";
    },
    donutSize() {
      if (
        this.$vuetify.breakpoint.name == "lg" ||
        this.$vuetify.breakpoint.name == "xl"
      ) {
        return 170;
      }
      return 125;
    },
  },
};
</script>
<style type="scss" lang="scss">
@import '../assets/css/variables.scss';

.bgHead {
  background-color: $systemcolor;
  color: #fff !important;
}
@media only screen and (min-width: 960px) {
  #last-payroll {
    height: 20%;
  }
  #donut {
    height: 35%;
  }
  #chart {
    height: 45%;
  }

  #sea-legend {
    height: 100%;
  }
}
</style>
